import React, { useState } from "react";
import { OptionTemplate } from "shared/api/middleware-api-client";
import InformationIcon from "shared/ui/icons/Information";
import { getFormattedPrice } from "shared/utils/getFormattedPrice";
import DoorMobileDrawer from "widgets/configurator/door-options-footer/components/drawer/DoorMobileDrawer";
import MonthlyPaymentModal from "widgets/shared/montly-payment-modal";

export interface DoorOptionsFooterProps {
  selectedDoor: OptionTemplate | null;
  isMonthlyPaymentAvailable: boolean;
  monthlyPayment?: number;
  addToCart: () => void;
  getConfigurationPrice: () => number;
  isSelfAssembly?: boolean;
}

export const DoorOptionsFooterMobile: React.FC<DoorOptionsFooterProps> = ({
  selectedDoor,
  monthlyPayment,
  addToCart,
  getConfigurationPrice,
}) => {
  const [isMonthlyPaymentModalOpened, setIsMonthlyPaymentModalOpened] =
    useState(false);

  if (!selectedDoor) return null;

  const showMonthlyPayment = monthlyPayment && monthlyPayment > 0;

  return (
    <>
      <MonthlyPaymentModal
        isOpen={isMonthlyPaymentModalOpened}
        setIsOpen={setIsMonthlyPaymentModalOpened}
      />
      <div className="gg-relative gg-grid gg-min-h-[98px] gg-w-full gg-border-t-2 gg-border-gray-200 gg-bg-gray-50 gg-shadow-inner">
        <div className="gg-flex gg-flex-col">
          <div className="gg-flex gg-w-full gg-flex-row gg-justify-between gg-pb-2 gg-pl-3 gg-pr-1.5 gg-pt-3 sm:gg-px-8">
            <div className="gg-flex gg-w-[70%] gg-flex-col gg-items-start gg-space-y-0.5">
              <div className="gg-flex gg-max-w-[80%]">
                {/* Selected door name */}
                <p className="gg-text-pretty gg-w-0 gg-whitespace-nowrap gg-break-words gg-text-[14.5px] gg-font-bold gg-text-dark-blue sm:gg-text-lg">
                  {selectedDoor.name}
                </p>
              </div>
              {/* Price formatted output */}
              <div className="gg-flex gg-items-center gg-gap-x-1.5 gg-pt-1">
                <p
                  data-testid="mainProductPrice"
                  className="gg-self-center gg-text-sm gg-font-bold gg-leading-5 gg-text-dark-blue/80 sm:gg-text-lg"
                >
                  {getFormattedPrice(getConfigurationPrice())}
                </p>
                <button
                  className="gg-mt-0.5"
                  type="button"
                  aria-label="Meer informatie over betalen per maand"
                  onClick={() =>
                    setIsMonthlyPaymentModalOpened(!isMonthlyPaymentModalOpened)
                  }
                >
                  <InformationIcon
                    className="gg-fill-gray-500 hover:gg-fill-gray-900"
                    width={19}
                    height={19}
                  />
                </button>
                {/* {isSelfAssembly && (
                  <h5
                    data-testid="originalSelfAssemblyPrice"
                    className="gg-relative gg-self-center gg-text-xs gg-font-bold gg-text-grey-100 sm:gg-text-sm"
                  >
                    {getFormattedPrice(
                      getConfigurationPrice() +
                        (selectedDoor.selfAssemblyDiscount || 0),
                    )}
                    <span className="gg-absolute gg-left-0 gg-top-1 gg-h-px gg-w-full gg-origin-left gg-rotate-12 gg-bg-grey-100"></span>
                  </h5>
                )} */}
              </div>

              <div className="gg-flex gg-items-center">
                {/* Monthly payment */}
                <p
                  className={`gg-w-18 gg-text-[10px] gg-text-dark-blue/80 gg-transition-opacity gg-delay-150 gg-duration-300 gg-ease-in-out ${
                    showMonthlyPayment ? "gg-opacity-100" : "gg-opacity-0"
                  }`}
                >
                  of v.a. €{monthlyPayment} p/m
                </p>
                {/* Monthly payment info icon */}

                {/* Spray pay info */}
                {/* <button
                  className="gg-mt-0.5"
                  onClick={() =>
                    setIsMonthlyPaymentModalOpened(!isMonthlyPaymentModalOpened)
                  }
                >
                  <InformationIcon
                    className="gg-fill-gray-500 hover:gg-fill-gray-900"
                    width={19}
                    height={19}
                  />
                </button> */}
              </div>
            </div>
            {/* Buttons  */}
            <button
              type="button"
              onClick={() => addToCart()}
              data-testid="add-to-cart-mobile"
              className="gg-mt-2 gg-h-min gg-justify-center gg-self-center gg-whitespace-nowrap gg-rounded-[4px] gg-bg-yellow-300 gg-px-4 gg-py-2 gg-text-[10.5px] gg-font-bold gg-text-dark-blue hover:gg-bg-yellow-400 hover:gg-text-zinc-900 sm:gg-px-8 md:gg-px-12"
            >
              In winkelmand
            </button>
          </div>
        </div>

        <div className="gg-absolute gg-bottom-1.5 gg-left-1/2 -gg-translate-x-1/2 gg-transform">
          <DoorMobileDrawer addToCart={addToCart} />
        </div>
      </div>
    </>
  );
};
